import {useContext} from 'react';
import MainLayout from '../../components/Layouts/MainLayout/MainLayout';

import Bottles from '../../components/UIElements/Bottles/Bottles';
import TastingCollection from '../../components/UIElements/TastingCollection/TastingCollection';
import ImageBanner from '../../components/UIElements/ImageBanner/ImageBanner';

import CartContext from '../../store/cart-context';
import PromotionCodeContext from '../../store/promotion-code-context';

import ReactGA from 'react-ga4';
import {eventNames, eventCategories} from '../../helpers/analytics-helpers';
import {bottleDescriptions} from '../../helpers/bottle-helpers';

const OurOliveOils = props => {

	const cartCtx = useContext(CartContext);
	const promoCodeCtx = useContext(PromotionCodeContext);

	const academyBannerCTAAnalyticsHandler = () => {
		ReactGA.event({
    	category: eventCategories.ENGAGEMENT, 
    	action: eventNames.CLICKED_ACADEMY_BANNER_CTA,
    	label: 'ourOliveOils'
    });
	}

	const banner = {
		image: 'academy-promo-banner.webp',
		mobileImage: 'academy-promo-mobile-banner.webp',
		altText: 'Level up your olive oil know-how with True Olive Academy',
		title: 'Level up your olive oil know-how with True Olive Academy',
		body: 'True Olive Academy will get you up to speed on the health benefits of high-quality olive oil, how you can identify and choose high-quality olive oil, and how you can delight and nurture your senses with curated recipes.',
		CTA: 'Level up with True Olive Academy',
		linkTo: '/academy/choosing-olive-oil',
		analyticsHandler: ()=>academyBannerCTAAnalyticsHandler()
	}

	const bottlesArray = [
		{
			id: 0,
			title: 'Luxe',
			bottle: '375 ml bottle',
			description: bottleDescriptions.LUXE,
			img: 'luxe',
			listPrice: cartCtx.getItemListPrice('luxe'),
			displayPrice:cartCtx.getItemDiscountedPrice('luxe', promoCodeCtx.percentOff),
			clickHandler: ()=>cartCtx.addItem('luxe')
		},
		{
			id: 1,
			title: 'Private Reserve',
			bottle: '375 ml bottle',
			description: bottleDescriptions.PRIVATE_RESERVE,
			img: 'private-reserve',
			listPrice: cartCtx.getItemListPrice('privateReserve'),
			displayPrice:cartCtx.getItemDiscountedPrice('privateReserve', promoCodeCtx.percentOff),
			clickHandler: ()=>cartCtx.addItem('privateReserve'),
			soldOut: false
		},
		{
			id: 2,
			title: 'Tasting Collection',
			bottle: 'A 375ml bottle of each',
			description: bottleDescriptions.TASTING_COLLECTION,
			img: 'tasting-collection',
			listPrice: cartCtx.getItemListPrice('tastingCollection'),
			displayPrice:cartCtx.getItemDiscountedPrice('tastingCollection', promoCodeCtx.percentOff),
			clickHandler: ()=>cartCtx.addItem('tastingCollection'),
			soldOut: false
		}
	];

	return (
		<MainLayout bottomCTA='default'>
			<div className='container'>
				<div className='row'>
					<Bottles bottlesArray={bottlesArray} />
					<div className='col-12 mb-4'><ImageBanner banner={banner}/></div>
				</div>
			</div>
		</MainLayout>
	)
}

export default OurOliveOils;

